import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import TitleSection from "src/components/TitleSection/TitleSection";

const NuitElite = () => {
  const { t, i18n } = useTranslation();

  return (
    <NuitEliteDiv>
      <Hero
        bgImage="promotions/gaming-machines/nuit-elite/nuit-elite-hero-image-2400x800px.jpg"
        buttonSettings={null}
        image={
          "promotions/gaming-machines/nuit-elite/nuit-elite-logo-2400x2400px.png"
        }
        darkenBg={0.5}
        title={t("nuitElite.hero.title")}
        descriptionBgColor="#0000004d"
      />
      <MainContentDiv>
        <container-div>
          <TitleSection
            as={"h2"}
            title={t("nuitElite.content.subtitle")}
            text={t("nuitElite.content.text")}
            borderColor="#CBB695"
          />
          <Row className="g-4 mb-0 mt-0 align-items-center" id="">
            <Col className="mt-0" xs={12} md={12}>
              <ReactMarkdown className="desc">
                {t("nuitElite.content.description")}
              </ReactMarkdown>
              <ReactMarkdown>{t("nuitElite.content.details")}</ReactMarkdown>
              <ReactMarkdown>
                {t("nuitElite.content.qualify")}
              </ReactMarkdown>
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
    </NuitEliteDiv>
  );
};

const NuitEliteDiv = styled.div`
  width: 100%;
  height: auto;
  /* min-height: 100vh; */
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }
  .small {
    text-align: center;
  }
  strong {
    color: #CBB695;
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  h2:after {
    border-color: #c7b997;
  }
  @media (min-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
  container-div {
    background-color: var(--lightblack);
  }
  @media (min-width: 992px) {
    padding: 3rem 0;
  }
  height: auto;
  width: 100%;
  text-align: left;
  ul {
    list-style: none;
    p {
      margin: 10px 0;
    }
    li {
      white-space: unset;
    }
  }
  .row {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    .col-12 {
      .subtitle-section {
        @media (min-width: 768px) {
          padding-top: 0;
        }
      }
    }
  }
`;

export default NuitElite;
